import { innerJoin } from 'ramda';

export default innerJoin;
